import React, { useEffect, useState, useRef } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { content } from '../mockData';

const ExpansionSection = () => {
  const { language } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  const expansionContent = content[language].expansion;

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section 
      id="expansion" 
      ref={sectionRef}
      className="section section-ivory"
    >
      <div className="container-narrow">
        {/* Header */}
        <div className={`text-center mb-64 fade-in-up ${isVisible ? 'visible' : ''}`}>
          <h2 className="mb-32">{expansionContent.title}</h2>
          <p>{expansionContent.intro}</p>
        </div>

        {/* Capacity Grid */}
        <div className="stats-grid mb-64">
          {expansionContent.capacity.map((item, index) => (
            <div
              key={item.label}
              className={`stat-item fade-in-up ${isVisible ? 'visible' : ''}`}
              style={{ transitionDelay: `${0.2 + index * 0.15}s` }}
            >
              <div className="stat-value" style={{ color: 'var(--olive)' }}>
                {item.value}
              </div>
              <div className="stat-label mb-16">{item.label}</div>
              <p style={{ fontSize: '0.9375rem', color: '#5a5a5a' }}>
                {item.description}
              </p>
            </div>
          ))}
        </div>

        {/* Full Estate Map */}
        <div 
          className={`image-container fade-in-up ${isVisible ? 'visible' : ''}`}
          style={{ 
            height: '600px', 
            marginBottom: '64px',
            transitionDelay: '0.55s'
          }}
        >
          <img src="/estate_map_full.png" alt="Full Estate Expansion Map" style={{ objectFit: 'contain' }} />
        </div>

        {/* Priority Note */}
        <div 
          className={`text-center mb-48 fade-in-up ${isVisible ? 'visible' : ''}`}
          style={{ transitionDelay: '0.6s' }}
        >
          <p style={{ 
            fontSize: '1rem',
            fontWeight: 500,
            color: 'var(--charcoal)',
            maxWidth: '700px',
            margin: '0 auto'
          }}>
            {expansionContent.priority}
          </p>
        </div>

        {/* Note */}
        <div 
          className={`text-center fade-in-up ${isVisible ? 'visible' : ''}`}
          style={{ transitionDelay: '0.65s' }}
        >
          <p style={{ 
            fontSize: '0.9375rem',
            fontStyle: 'italic',
            color: 'var(--stone)',
            maxWidth: '700px',
            margin: '0 auto'
          }}>
            {expansionContent.note}
          </p>
        </div>
      </div>
    </section>
  );
};

export default ExpansionSection;
